import { PayloadlessAction } from '@/types/redux';

export const LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';
export type LogOutBidderSuccessAction = PayloadlessAction<typeof LOG_OUT_BIDDER>;
export const logOutBidder = () => ({ type: LOG_OUT_BIDDER });
